/**
 * AppPage — wrapper sobre Polaris Page.
 * Visual: idéntica a Polaris Page hoy.
 * Beneficio: las páginas no importan directamente @shopify/polaris.
 * Migración futura: cambiar solo este archivo.
 */
import { Page } from '@shopify/polaris';
import type { ReactNode } from 'react';

export interface AppPagePrimaryAction {
  content: string;
  onAction?: () => void;
  disabled?: boolean;
  icon?: unknown;
  /** Spinner dentro del botón mientras se guarda (Polaris ya lo soporta). Sin
   *  esto, un guardado lento no daba ninguna señal y el usuario clickeaba dos veces. */
  loading?: boolean;
}

export interface AppPageSecondaryAction {
  content: string;
  onAction?: () => void;
  actions?: { content: string; onAction: () => void }[];
}

export interface AppPageBackAction {
  content: string;
  onAction?: () => void;
  url?: string;
}

export interface AppPageProps {
  title?: ReactNode;
  /** Breadcrumb (flecha "‹ …") arriba del título — patrón Polaris para páginas hijas. */
  backAction?: AppPageBackAction;
  primaryAction?: AppPagePrimaryAction;
  /** Acepta un array de acciones (botones estándar) O un ReactNode para
   *  controles custom (ej. un ButtonGroup segmented para view switcher,
   *  que no cabe en el modelo de MenuActionDescriptor). */
  secondaryActions?: AppPageSecondaryAction[] | ReactNode;
  /** Ancho ampliado (patrón índice de Shopify): usa el `fullWidth` de Polaris + una regla
   *  única en polaris.css (`.Polaris-Page--fullWidth { max-width: 1400px }`) que lo capea a un
   *  ancho cómodo y lo centra. Uniforme: header + contenido alineados. Para listas densas. */
  fullWidth?: boolean;
  children?: ReactNode;
}

export function AppPage({ title, backAction, primaryAction, secondaryActions, fullWidth, children }: AppPageProps) {
  return (
    <Page
      title={title as string}
      backAction={backAction}
      primaryAction={primaryAction}
      secondaryActions={secondaryActions as AppPageSecondaryAction[] | React.ReactElement}
      fullWidth={fullWidth}
    >
      {children}
    </Page>
  );
}
